import { Button, Table, Tag } from "antd";
import { Staff } from "../../entities/interfaces/staffs";
import DesignationTag from "../misc/DesignationTags";

type Props = {
  staffs: Staff[];
  onSelect: (staff: Staff) => void;
};

const StaffList = ({ staffs, onSelect }: Props) => {
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Designation",
      key: "designation",
      render: ({ designation }: any) => <DesignationTag value={designation} />,
    },
    {
      title: "Phone",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Status",
      key: "active",
      render: (record: any) => {
        return record.isActive ? (
          <Tag color="green">Active</Tag>
        ) : (
          <Tag color="red">Inactive</Tag>
        );
      },
    },
    {
      title: "Action",
      key: "action",
      render: (record: any) => {
        return (
          <Button size="small" onClick={() => onSelect(record)}>
            Update
          </Button>
        );
      },
    },
  ];

  return <Table dataSource={staffs} columns={columns} />;
};

export default StaffList;
